import { useFormContext } from 'react-hook-form';
import { useMemo } from 'react';
import {
    FORM_SECTIONS,
    requiredAboutYouFields,
    requiredBTFields,
    requiredCurrentAddressFields,
    requiredEmploymentFields,
    requiredOutgoingFields,
    requiredPreviousAddressFields
} from './FormIDs';
import { useFormData } from '../../../components/FormDataContext';

export const useProgressBar = () => {
    const { formState, getValues } = useFormContext();
    // @ts-expect-error TS2339: Property 'isBT' does not exist on type 'unknown'.
    const { isBT } = useFormData();
    // @ts-expect-error TS2769: No overload matches this call.
    const isInterestedInBT = getValues(FORM_SECTIONS.AboutYou.InterestedInBT) === 'Y';
    // @ts-expect-error TS18048: 'FORM_SECTIONS.Address.Current' is possibly 'undefined'.
    const requiresPreviousAddress = getValues(FORM_SECTIONS.Address.Current.YearsAtAddress) < 2;
    return useMemo(() => {
        const sections = [
            [...requiredAboutYouFields, ...(isBT && isInterestedInBT ? requiredBTFields : [])],
            requiredEmploymentFields,
            requiredOutgoingFields,
            [...requiredCurrentAddressFields, ...(requiresPreviousAddress ? requiredPreviousAddressFields : [])]
        ];

        const isSectionComplete = (section: any) => {
            return section.every((fieldName: any) => {
                const hasError = !!formState.errors[fieldName];
                const fieldValue = getValues(fieldName);
                return !hasError && !!fieldValue;
            });
        };

        const completedStages = sections.filter((section) => isSectionComplete(section));
        const currentStageIndex = completedStages.length;
        const totalStages = sections.length + 1; // Need to include the "starting section" where a section is not completed but a user has started to fill out the form

        return { currentStageIndex, totalStages };
    }, [formState, getValues, isBT, isInterestedInBT, requiresPreviousAddress]);
};
